var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoals(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#33C189"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 9.25C17.7141 9.25 18.1592 9.06563 18.4874 8.73744C18.8156 8.40925 19 7.96413 19 7.5C19 7.03587 18.8156 6.59075 18.4874 6.26256C18.1592 5.93437 17.7141 5.75 17.25 5.75C16.7859 5.75 16.3408 5.93437 16.0126 6.26256C15.6844 6.59075 15.5 7.03587 15.5 7.5C15.5 7.96413 15.6844 8.40925 16.0126 8.73744C16.3408 9.06563 16.7859 9.25 17.25 9.25ZM6.22281 16.95H13.3366H14.9772H17.6634C18.4028 16.95 19 16.3506 19 15.6134C19 15.3684 18.9322 15.1278 18.8053 14.9178L15.9178 10.1863C15.8281 10.0397 15.6706 9.95 15.5 9.95C15.3294 9.95 15.1719 10.0397 15.0822 10.1841L14.0278 11.9122L11.2737 7.52188C11.1294 7.29 10.8734 7.15 10.6 7.15C10.3266 7.15 10.0728 7.29 9.92625 7.52188L5.18812 15.0775C5.06563 15.2722 5 15.4975 5 15.7272C5 16.4031 5.54688 16.95 6.22281 16.95Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoals);
export default __webpack_public_path__ + "static/media/goals.acdef5bcd5a86ec8c0141acb0600b5eb.svg";
export { ForwardRef as ReactComponent };